/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService
 */
import * as References from './LessonChirpService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService#getHydratedLesson
 */
export const GET_HYDRATED_LESSON_QUERY_FIELD_NAME =
  'com_hubspot_academy_catalog_rpc_LessonChirpService_getHydratedLesson';
export const GET_HYDRATED_LESSON_QUERY: RegisteredQuery<
  'result',
  References.GetHydratedLessonRequestType,
  References.GetHydratedLessonResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_HYDRATED_LESSON_QUERY_FIELD_NAME,
  args: ['lessonId'],
  fetcher(
    request: References.GetHydratedLessonRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetHydratedLessonResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getHydratedLessonRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService#getHydratedLessons
 */
export const GET_HYDRATED_LESSONS_QUERY_FIELD_NAME =
  'com_hubspot_academy_catalog_rpc_LessonChirpService_getHydratedLessons';
export const GET_HYDRATED_LESSONS_QUERY: RegisteredQuery<
  'result',
  References.GetHydratedLessonsRequestType,
  References.GetHydratedLessonsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_HYDRATED_LESSONS_QUERY_FIELD_NAME,
  args: ['language', 'fallbackLanguage'],
  fetcher(
    request: References.GetHydratedLessonsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetHydratedLessonsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getHydratedLessonsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService#getHydratedPartnerLessons
 */
export const GET_HYDRATED_PARTNER_LESSONS_QUERY_FIELD_NAME =
  'com_hubspot_academy_catalog_rpc_LessonChirpService_getHydratedPartnerLessons';
export const GET_HYDRATED_PARTNER_LESSONS_QUERY: RegisteredQuery<
  'result',
  References.GetHydratedPartnerLessonsRequestType,
  References.GetHydratedPartnerLessonsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_HYDRATED_PARTNER_LESSONS_QUERY_FIELD_NAME,
  args: ['language', 'fallbackLanguage'],
  fetcher(
    request: References.GetHydratedPartnerLessonsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetHydratedPartnerLessonsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getHydratedPartnerLessonsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
